
import Toast from 'vux/src/components/toast/index.vue'

export default {
components: {
Toast
},
props: {

kind: {
default: "",
type: String
},

tabKind: {
default: "",
type: String
},

chooseList: {
default: () => [],
type: Array
},

singleContent: {
default: "",
type: String
},

single_fav: {
default: false,
type: Boolean
},

singleStatus: {
default: false,
type: Boolean
},
select_id: {
default: "0"
},
pageKind: {
type: String,
default: ""
},
dataIndex: {
default: 1,
type: Number
},
islast: {
default: 0,
type: Number
},
islast_length: {
default: 0,
type: Number
},
nowItemIndex: {
default: 0,
type: Number
}

},
data() {
return {
index: 1,
newList: [],
choosedItem: "",
singleFav: false,
showSubmit: true,
mulityChoosed: [],
key: "",
courseId: 0
};
},
watch: {
chooseList: {
handler(newVal, oldVal) {

this.newList = JSON.parse(JSON.stringify(this.chooseList));
this.newList = this.newList.map((item, index) => {
return {
...item,
target: String.fromCharCode(index + 65)
};
});
this.newList.forEach(item => {
if (String(this.select_id) && String(this.select_id).indexOf(item.id) > -1) {
this.$set(item, "chooseActive", true);
}
});
},

immediate: true
},
single_fav: {
handler(newVal, oldVal) {
this.singleFav = this.single_fav;
},
immediate: true
},
singleStatus: {
handler(newVal, oldVal) {
if (newVal) {
this.showSubmit = false;
} else {
this.showSubmit = true;
}
},
immediate: true
}










},
created() {
this.keys = this.$route.query.keys;
this.courseId = this.$route.query.courseId;
},
mounted() {},

methods: {

chooseItem(val) {
if (this.pageKind === "exam") {
if (this.tabKind === "single") {
if (val.chooseActive) return;
this.newList.forEach(item => {
this.$set(val, "chooseActive", false);
delete item.chooseActive;
});
this.$set(val, "chooseActive", true);
this.$emit(
"chooseItem",
this.tabKind,
val.id,
val.target,
this.newList
);
this.choosedItem = val.target;
} else {

if (val.chooseActive) {
this.$set(val, "chooseActive", false);
} else {
this.$set(val, "chooseActive", true);
}
this.mulityChoosed = this.newList.filter(item => {
return item.chooseActive == true;
});
let targetArr = [];
this.mulityChoosed.forEach(item => {
targetArr.push(item.target);
});
let idArr = [];
this.mulityChoosed.forEach(item => {
idArr.push(item.id);
});
this.$emit(
"chooseItem",
this.tabKind,
idArr,
targetArr,
this.newList
);
}
return;
}
if (!this.showSubmit) return;

if (this.tabKind === "single") {
if (val.chooseActive) return;
this.newList.forEach(item => {
this.$set(val, "chooseActive", false);
delete item.chooseActive;
});
this.$set(val, "chooseActive", true);
this.$emit(
"chooseItem",
this.tabKind,
val.id,
val.target,
this.newList
);
this.choosedItem = val.target;
} else {

if (val.chooseActive) {
this.$set(val, "chooseActive", false);
} else {
this.$set(val, "chooseActive", true);
}
this.mulityChoosed = this.newList.filter(item => {
return item.chooseActive == true;
});
let targetArr = [];
this.mulityChoosed.forEach(item => {
targetArr.push(item.target);
});
let idArr = [];
this.mulityChoosed.forEach(item => {
idArr.push(item.id);
});
this.$emit("chooseItem", this.tabKind, idArr, targetArr, this.newList);
}
},

chooseSubmit() {




if (this.tabKind === "single") {
let t = this.newList.find(item => {
return item.chooseActive == true;
});
if (!t) {
this.$vux.toast.text("请选择后提交");
return;
}
this.$emit("chooseSubmit", this.tabKind, t.target, this.newList);
} else if (this.tabKind === "multiple") {
let t_2 = this.newList.filter(item => {
return item.chooseActive == true;
});
if (!t_2 || !t_2.length) {
this.$vux.toast.text("请选择后提交");
return;
}
let t_3 = [];
t_2.forEach(item => {
t_3.push(item.target);
});
this.$emit("chooseSubmit", this.tabKind, t_3.sort().toString().split(","), this.newList);
}

},
collect() {

this.$emit("collect");
},
unCollect() {

this.$emit("unCollect");
},
deleteItem() {
this.$emit("deleteItem");
}
}
};



// WEBPACK FOOTER //
// ./src/components/exam/chooseSubject.vue